module.exports = __webpack_public_path__ + "img/Shape.ef978461.svg";